<!--
 * @Author: linghujie 391103334@qq.com
 * @Date: 2023-03-10 09:25:50
 * @LastEditors: linghujie 391103334@qq.com
 * @LastEditTime: 2023-03-10 16:36:16
 * @FilePath: \full-electric-charging-pile-website\src\components\Footer.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div id="footer" class="container-fluid">
    <div class="logo">
      <img src="@/assets/img/logo_white.png" alt="logo图">
    </div>
    <p class="title">上海幻筱科技有限公司</p>
    <div class="address_tel_fax">
      <p>地址：上海市闵行区万源路2800号</p>
      <p>Tel：4006-059-526</p> 
    </div> 
    <p class="copy">Copyright &copy; 2023 上海幻筱科技有限公司</p>
    <p class="copy" style="margin-top:10px;">备案号:<a href="https://beian.miit.gov.cn/">沪ICP备2023006296号</a></p>
  </div>
</template>
<script>
export default {
  name: "Footer",
  data() {
    return {};
  }
};
</script>
<style scoped>
#footer {
  width: 100%;
  height: 100%;
  color: #fff;
  background: #474747;
  overflow: hidden;
  text-align: center;
}
.logo img{
  /* width: 160px; */
  height: 60px;
  margin: 50px auto 20px;
}
.title {
  font-size: 25px;
  margin-bottom: 20px;
}
.address_tel_fax {
  color: #d3d3d3;
  font-size: 14px;
  margin: 10px 0;
}
.email_wx {
  color: #d3d3d3;
  font-size: 14px;
}
.copy {
  color: #d3d3d3;
  font-size: 14px;
  margin: 50px 0 10px;
}
@media screen and (max-width: 997px) {
  .title {
    font-size: 20px;
  }
  .address_tel_fax {
    font-size: 12px;
  }
  .email_wx {

  font-size: 12px;
}
.copy {
  font-size: 12px;
  margin: 30px 0 10px;
}
}
</style>




// WEBPACK FOOTER //
// src/components/Footer.vue